export default __webpack_public_path__ + "static/media/sale4.0a685c21.webp";